import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";
import { SelectField } from "ComponentsUI/Selectfield";
import AddressSearchHomeContainerB from "Containers/AddressSearchHomeContainerB";
import Textarea from "react-textarea-autosize";
import Carousel from "nuka-carousel";
import AlertWrapper from "ComponentsUI/AlertWrapper";
import Container from "reactstrap/lib/Container";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import Button from "ComponentsUI/Button";
import LoginLogic from "HOC/LoginLogic";
import { Link } from "react-router-dom";
import { RatingStar } from "ComponentsUI/RatingsViews";
import TermsOfUse from "ComponentsUI/TermsOfUse";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";

const styles = (theme) => ({
	headerWrapper: {
		width: "100%",
		display: "flex",
		justifyContent: "center",
		marginBottom: "90px",
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "36px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		marginTop: "60px",
		margin: 0,
		minHeight: "36px",
	},
	closeWrapper: {
		position: "relative",
	},
	buttonBack: {
		width: "60px",
		height: "60px",
		position: "absolute",
		borderRadius: "50%",
		border: `solid 1px ${theme.palette.colors.oneMoreGrey}`,
		top: "50px",
		right: 0,
		transition: "opacity .3s ease",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		zIndex: 100,
		"& span": {
			fontSize: "16px",
			color: theme.palette.colors.disabled,
		},
	},
	commonHeader: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 1,
		letterSpacing: "2.3px",
		color: theme.palette.colors.darkSlateBlue,
		marginBottom: "17px",
		textTransform: "uppercase",
		display: "flex",
		alignItems: "center",
		position: "relative",
	},
	modal: {
		width: "auto",
		height: "auto",
		border: `1px solid transparent`,
		background: `linear-gradient(to bottom right, #3C8CD3, 50%, ${theme.palette.colors.purplishBlue})`,
		borderRadius: "12px",
		display: "flex",
		flexDirection: "column",
		position: "absolute",
		top: "-140px",
		left: "-10px",
	},
	modalButtonClose: {
		display: "flex",
		justifyContent: "flex-end",
	},
	modalConteiner: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		padding: "0px 40px 40px 40px",
		justifyContent: "center",
	},
	modalText: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.13,
		letterSpacing: "normal",
		color: theme.palette.colors.white,
		marginRight: "10px",
		textAlign: "center",
	},
	modalButtonLook: {
		width: "auto",
		height: "auto",
	},
	bodySection: {
		position: "relative",
		borderBottom: `1px solid ${theme.palette.colors.transparent}`,
		padding: "60px 0",
		"&:after": {
			content: "''",
			position: "absolute",
			bottom: 0,
			left: 0,
			width: "100%",
			height: "1px",
			backgroundColor: theme.palette.colors.disabled,
		},
		"&:first-child": {
			paddingTop: 0,
		},
		"&:last-child": {
			"&:after": {
				display: "none",
			},
		},
	},
	bodyHint: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1.13,
		letterSpacing: "normal",
		color: theme.palette.colors.oneMoreGrey,
	},
	bodyRatingHint: {
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.13,
		letterSpacing: "normal",
		color: theme.palette.colors.darkSlateBlue,
	},
	bodyReviewWrapper: {
		marginBottom: "65px",
		position: "relative",
		"& $bodyHint": {
			marginBottom: "17px",
		},
		"& $commonHeader": {
			marginBottom: "12px",
		},
	},
	bodyRadioGroup: {
		marginTop: "28px",
	},
	bodyRadioGroupError: {
		marginTop: "15px",
	},
	timeUsed: {
		marginBottom: "17px",
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.13,
		letterSpacing: "normal",
		color: theme.palette.colors.darkSlateBlue,
	},
	serviceUsed: {
		margin: "28px 0 17px",
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.13,
		letterSpacing: "normal",
		color: theme.palette.colors.darkSlateBlue,
	},
	bodyReviewCounter: {
		position: "absolute",
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		color: theme.palette.colors.oneMoreGrey,
		right: "15px",
		bottom: "20px",
	},

	bodyRatingsList: {
		marginTop: "40px",
		display: "flex",
		flexWrap: "wrap",
	},
	bodyRatingsItem: {
		width: "40%",
		marginBottom: "56px",
		position: "relative",
		"&:last-child": {
			marginBottom: 0,
		},
		"&:nth-child(2n)": {
			marginLeft: "auto",
		},
		"&:nth-child(2n + 1)": {
			marginRight: "auto",
		},
	},
	bodyRatingsItemDescription: {
		fontFamily: theme.fonts.light,
		fontSize: "14px",
		color: theme.palette.colors.oneMoreGrey,
		marginBottom: "17px",
	},
	stars: {
		width: "180px",
	},
	star: {
		fontSize: "24px",
		color: theme.palette.colors.purplishBlue,
		cursor: "pointer",
	},
	bodyFiltersContainer: {
		marginBottom: 0,
		display: "flex",
		marginTop: "5px",
	},
	bodyFiltersSlotShort: {
		width: "385px",
	},
	bodyFiltersSlotLong: {
		width: "385px",
		marginRight: "16px",
	},
	bodyAddressWrapper: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-end",
		marginBottom: "35px",
		width: "580px",
	},
	bodyAddressStreet: {
		width: "100%",
	},
	commonInput: {
		width: "100%",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.disabled}`,
		padding: "0 20px",
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		backgroundColor: theme.palette.colors.paleGrey,
		"&:focus": {
			backgroundColor: theme.palette.colors.white,
		},
	},
	placeholder: {
		paddingLeft: "21px",
		top: "51%",
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		color: theme.palette.colors.oneMoreGrey,
		cursor: "pointer",
	},
	commonInputError: {
		borderColor: theme.palette.colors.coralPink,
	},
	commonTA: {
		width: "100%",
		minHeight: "150px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.disabled}`,
		resize: "none",
		padding: "20px 20px 40px",
		overflow: "hidden",
		backgroundColor: theme.palette.colors.paleGrey,
		"&:focus": {
			backgroundColor: theme.palette.colors.white,
		},
	},
	commonTAError: {
		borderColor: theme.palette.colors.coralPink,
	},
	radioGroup: {
		display: "flex",
	},
	radioGroupItem: {
		width: "300px",
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
	},
	radioGroupItemFakeInputChecked: {
		backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='rgb(88, 18, 254)'/%3e%3c/svg%3e")`,
	},
	radioGroupItemFakeInput: {
		width: "30px",
		height: "30px",
		marginRight: "14px",
		flexShrink: 0,
		border: `solid 2px ${theme.palette.colors.darkSlateBlue}`,
		borderRadius: "50%",
	},
	radioGroupItemText: {
		fontFamily: theme.fonts.medium,
		fontSize: "18px",
		fontWeight: 500,
		lineHeight: 0.89,
		color: theme.palette.colors.darkSlateBlue,
		userSelect: "none",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		bodyTagsWrapper: {
			margin: "80px 0 85px",
		},
		modal: {
			top: "-180px",
			left: "-6px",
		},
		modalConteiner: {
			flexDirection: "column",
			padding: "0px 20px 20px 20px",
		},
		modalButtonLook: {
			marginTop: "20px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		headerWrapper: {
			marginBottom: "60px",
		},
		header: {
			marginTop: "40px",
		},
		modal: {
			top: "-180px",
			left: "-6px",
		},
		modalConteiner: {
			flexDirection: "column",
			padding: "0px 20px 20px 20px",
		},
		modalButtonLook: {
			marginTop: "20px",
		},
		buttonBack: {
			top: "30px",
		},
		bodySection: {
			padding: "40px 0",
		},
		bodyTagsWrapper: {
			margin: "80px 0 85px",
		},
		bodyFiltersSlotShort: {
			width: "185px",
		},
		bodyFiltersSlotLong: {
			width: "385px",
			marginRight: "38px",
		},
		radioGroupItem: {
			width: "235px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		headerWrapper: {
			marginBottom: "40px",
		},
		header: {
			fontSize: "24px",
			minHeight: "24px",
			marginTop: "46px",
		},
		buttonBack: {
			width: "20px",
			height: "20px",
			borderRadius: 0,
			border: "none",
			top: "20px",
			"& span": {},
		},
		commonHeader: {
			fontSize: "14px",
			lineHeight: 1.14,
			letterSpacing: "2px",
			marginBottom: "12px",
		},
		modal: {
			top: "-160px",
			left: "-6px",
		},
		modalConteiner: {
			flexDirection: "column",
			padding: "0px 20px 20px 20px",
		},
		modalButtonLook: {
			marginTop: "20px",
		},

		bodySection: {
			padding: "20px 0",
			"&:after": {
				left: "-20px",
				right: "-20px",
				width: "auto",
			},
		},
		bodyReviewWrapper: {
			marginBottom: "25px",
		},
		bodyHint: {
			fontSize: "14px",
			lineHeight: 1.14,
		},
		bodyRatingHint: {
			fontSize: "14px",
			lineHeight: 1.14,
		},
		bodyRatingsList: {
			marginTop: "33px",
		},
		bodyRatingsItem: {
			marginBottom: "45px",
			position: "relative",
			width: "100%",
		},
		bodyFiltersContainer: {
			marginBottom: "22px",
			flexWrap: "wrap",
		},
		bodyFiltersSlotLong: {
			width: "100%",
			marginBottom: "22px",
			marginRight: 0,
		},
		bodyFiltersSlotShort: {
			width: "100%",
		},
		bodyAddressWrapper: {
			marginTop: "29px",
			marginBottom: "22px",
			flexWrap: "nowrap",
			width: "100%",
		},
		bodyAddressStreet: {
			width: "100%",
		},
		placeholder: {
			top: "52%",
		},
		commonTA: {
			minHeight: "100px",
		},
		timeUsed: {
			marginBottom: "12px",
		},
		serviceUsed: {
			marginBottom: "12px",
		},
		radioGroup: {
			flexDirection: "column",
		},
		radioGroupItem: {
			marginBottom: "12px",
			"&:last-child": {
				marginBottom: 0,
			},
		},
	},
});

class AddReviewWrapper extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			wasMount: false,
		};
		let text = this.props.text;
		this.errorText = text.SEND_REVIEW_ERROR;
		this.errorTextRatings = text.SEND_REVIEW_RATINGS_ERROR;
	}

	componentDidMount() {
		this.init();
	}

	componentWillUnmount() {
		this.props.scrollToTop();
	}

	init() {
		this.setState({
			wasMount: true,
		});
	}

	changeMonthValue(item) {
		this.props.changeMonthValue && this.props.changeMonthValue(item);
	}

	changeServiceOfUse(item) {
		this.props.changeServiceOfUse && this.props.changeServiceOfUse(item);
	}

	scrollToError() {}

	generateRadioButtonsTime = (name) => {
		let classes = this.props.classes;
		let monthListValue = this.props.data.monthListValue;
		let monthList = this.props.data.monthList;
		return monthList.map((item, index) => {
			return (
				<div
					key={"mountList" + index}
					className={classes.radioGroupItem}
					onClick={() => this.changeMonthValue(item)}
				>
					<div
						className={classNames(classes.radioGroupItemFakeInput, {
							[classes.radioGroupItemFakeInputChecked]: monthListValue == item.id,
						})}
					/>
					<div className={classes.radioGroupItemText}>{item.name}</div>
				</div>
			);
		});
	};

	generateRadioButtonService = (name) => {
		let {
			classes,
			data: { serviceOfUseList, serviceOfUse },
		} = this.props;

		return serviceOfUseList.map((item, index) => {
			return (
				<div
					key={"serviceOfUseList" + index}
					className={classes.radioGroupItem}
					onClick={() => this.changeServiceOfUse(item)}
				>
					<div
						className={classNames(classes.radioGroupItemFakeInput, {
							[classes.radioGroupItemFakeInputChecked]: serviceOfUse == item.id,
						})}
					/>
					<div className={classes.radioGroupItemText}>{item.name}</div>
				</div>
			);
		});
	};

	changeModalValue() {
		this.props.changeModalValue && this.props.changeModalValue();
	}

	sendYandexMetrica = (target) => {
		Metrika.getInstance().yandex.sendEvent(target, []);
	};

	generateModal = () => {
		let {
			text,
			classes,
			data: { openModal },
		} = this.props;
		let match = this.props.match;

		this.sendYandexMetrica(YANDEX_TARGETS.OPEN_WATCH_FROM_FEEDBACK);

		return (
			<>
				{openModal ? (
					<div className={classes.modal}>
						<div className={classes.modalButtonClose}>
							<Button
								typeText={"small"}
								size={"low"}
								status={"simpleText"}
								onClick={() => this.changeModalValue()}
							>
								<span className="icon24 icon-close" />
							</Button>
						</div>
						<div className={classes.modalConteiner}>
							<div className={classes.modalText}>{text.FEEDBACK_MODAL_TEXT}</div>
							<div className={classes.modalButtonLook}>
								<Button
									typeText={"small"}
									onClick={() => this.sendYandexMetrica(YANDEX_TARGETS.CLICK_WATCH_FROM_FEEDBACK)}
									component={
										<Link
											to={generateUrl(Routes.Providers.route, {
												regionUrl: match.params.regionUrl,
											})}
										/>
									}
									size={"low"}
									status={"lightOrange"}
								>
									{text.LOOK}
								</Button>
							</div>
						</div>
					</div>
				) : (
					<></>
				)}
			</>
		);
	};

	generateRatings = () => {
		let ratingsArray = this.props.specifications;
		if (!!this.props.data.ratings) {
			ratingsArray = this.props.data.ratings;
		}
		if (!ratingsArray) {
			return null;
		}
		let classes = this.props.classes;
		return ratingsArray.map((item, index) => {
			return (
				<div key={index} className={classes.bodyRatingsItem} datatest="feedback_rating_button">
					{item.negative && this.generateModal()}
					<div className={classes.commonHeader}>{item.name}</div>
					<div className={classes.bodyRatingsItemDescription}>{item.description}</div>
					<div className={classes.stars}>
						<RatingStar
							classNameStar={classes.star}
							provider={true}
							onClickStarHandler={(value) => this.props.chooseMark(item, value + 1)}
							rating={item.value}
						/>
					</div>
				</div>
			);
		});
	};

	selectProvider = (item) => {
		this.typeInternetSelect.clearSingleSelect();
		this.props.selectProvider(item);
	};

	toNextSlide = () => {
		this.props.scrollToTop();
		setTimeout(() => {
			this.carousel?.nextSlide();
		}, 300);
		this.props.changeCurrentSlide(this.props.data.currentSlide + 1);
	};

	toPreviusSlide = () => {
		this.carousel.previousSlide();
		this.props.changeCurrentSlide(this.props.data.currentSlide - 1);
	};

	generateFirstSlide() {
		let disabledFirstButton = !this.props.checkFirstPart();
		let text = this.props.text;
		let classes = this.props.classes;
		let dataError = this.props?.data?.error || false;
		let addButton = (
			<Button
				onClick={() => this.props.sendReview(this.toNextSlide)}
				transparent={true}
				fullWidth={true}
				noPaddings={true}
				size="middle"
				status="simpleText"
			>
				{text.ANONIMOUSLY}
			</Button>
		);
		return (
			<Container
				key="1"
				style={{
					display: this.props.data.currentSlide != 0 ? "none" : "block",
				}}
			>
				<div className={classNames(classes.bodySection)}>
					<div className={classes.bodyFiltersContainer}>
						<div className={classes.bodyFiltersSlotLong}>
							<SelectField
								equalBy="value"
								error={this.props.data.error && !this.props.data.provider}
								windowSizes={this.props.windowSizes}
								allowInput={true}
								items={this.props.providers}
								onItemSelect={(item) => {
									this.selectProvider(item);
								}}
								title={text.FILTERS_PROVIDER}
								findItems={this.props.data.provider ? [this.props.data.provider] : []}
								text={text}
								placeholder={text.CHOOSE}
								activePlaceHolder={text.CHOOSE}
								datatest="feedback_input_provider"
							/>
						</div>
						<div className={classes.bodyFiltersSlotShort}>
							<SelectField
								allowInput={!!this.props.data.provider}
								windowSizes={this.props.windowSizes}
								equalBy="value"
								onMount={(data) => (this.typeInternetSelect = data)}
								key="typeInternetSelect"
								error={this.props.data.error && !this.props.data.typeOfInternet}
								items={this.props.data.provider ? this.props.data.provider.order_types : []}
								text={text}
								onItemSelect={(item) => this.props.selectOrderType(item)}
								title={text.TENDER_INTERNET_SERVICE}
								findItems={this.props.data.typeOfInternet ? [this.props.data.typeOfInternet] : []}
								placeholder={text.CHOOSE}
								activePlaceHolder={text.CHOOSE}
								datatest="feedback_input_internettype"
							/>
						</div>
					</div>
				</div>
				<div className={classNames(classes.bodySection)}>
					<AlertWrapper
						error={this.props.data.error && !this.props.checkRatings() && this.errorTextRatings}
						isReview={true}
					>
						<div className={classes.bodyRatingHint}>{text.SEND_REVIEW_MARKS}</div>
					</AlertWrapper>
					<div
						className={classNames({
							[classes.bodyRadioGroup]: !dataError,
							[classes.bodyRadioGroupError]: dataError,
						})}
					>
						<div className={classes.timeUsed}>{text.time_of_used}</div>
						<div className={classes.radioGroup} datatest={"time_used"}>
							{this.generateRadioButtonsTime("time_of_use")}
						</div>
						<div className={classes.serviceUsed}>{text.service_of_used_question}</div>
						<div className={classes.radioGroup} datatest={"service_used"}>
							{this.generateRadioButtonService("service_of_use")}
						</div>
					</div>
					<div className={classes.bodyRatingsList}>{this.generateRatings()}</div>
				</div>
				<div className={classNames(classes.bodySection)}>
					<div className={classes.bodyAddressWrapper}>
						<div className={classes.bodyAddressStreet}>
							<div className={classes.commonHeader}>{text.filtersAddress}</div>
							<AddressSearchHomeContainerB
								tender={true}
								datatest="feedback_input_street_home"
								withoutContainer={true}
								withoutButton={true}
								withoutSwitcher={true}
								layoutB={true}
								onEnterHandler={() => {}}
								onCallback={this.props.updateCallback}
							/>
						</div>
					</div>
					<div className={classes.bodyReviewWrapper}>
						<div className={classes.commonHeader}>{text.YOUR_REVIEW}</div>
						<div className={classes.bodyHint}>{text.YOUR_REVIEW_LIMITS}</div>
						<Textarea
							datatest="feedback_comment"
							onChange={this.props.reviewChanges}
							value={this.props.data.reviewText}
							className={classNames(classes.commonTA, {
								[classes.commonTAError]:
									this.props.data.error && this.props.data.reviewText.length < 100,
							})}
						/>
						<div className={classes.bodyReviewCounter}>
							{this.props.data.reviewText.length} / 100
						</div>
					</div>
					<AlertWrapper error={this.props.data.error && this.errorText} center={true}>
						<LoginLogic
							succesfullCallback={() => this.props.sendReview(this.toNextSlide)}
							addButton={addButton}
						>
							<AddReviewSendButton
								text={text}
								setError={this.props.setError}
								scrollToError={() => this.scrollToError()}
								userIsAuth={this.props.userIsAuth}
								authHandler={() => this.props.sendReview(this.toNextSlide)}
								disabledFirstButton={disabledFirstButton}
							/>
						</LoginLogic>
					</AlertWrapper>
					<TermsOfUse isAddReview={true} buttonText={text.SEND_REVIEW} />
				</div>
			</Container>
		);
	}

	render() {
		let text = this.props.text;
		let classes = this.props.classes;

		return (
			<form>
				<Container>
					<div className={classes.closeWrapper}>
						<div onClick={this.props.closeHandler} className={classNames(classes.buttonBack)}>
							<span className="icon24 icon-close" />
						</div>
					</div>
				</Container>

				{!this.props.data.feedbackIsSended && (
					<Container>
						<div className={classes.headerWrapper}>
							<h1 className={classes.header}>{this.props.h1}</h1>
						</div>
					</Container>
				)}
				{!this.state.wasMount && this.generateFirstSlide()}
				{!!this.state.wasMount && (
					<Carousel
						ref={(carousel) => (this.carousel = carousel)}
						decorators={[]}
						heightMode="auto"
						cellSpacing={20}
						dragging={false}
						swiping={false}
						slideIndex={this.props.data.slideCount}
						needRecalculateHeight={true}
					>
						{this.generateFirstSlide()}
						<Container key="3">
							{this.props.data.feedbackIsSended && (
								<EmptyStub
									fullScreen={true}
									header={text.SEND_REVIEW_WELCOME_HEADER}
									text={text.SEND_REVIEW_WELCOME_TEXT}
									icon={
										<span
											className="icon48 icon-balance"
											style={{
												fontSize: "48px",
												color: "#5812fe",
											}}
										/>
									}
									button={
										<Button
											typeText={"small"}
											component={<Link to={!!this.props.urlToBack ? this.props.urlToBack : "/"} />}
											size={"low"}
											status={"withoutAccent"}
										>
											<span
												className="icon48 icon-chat-1"
												style={{
													fontSize: "24px",
													color: "#d3cee1",
												}}
											/>
											{text.ITS_CLEAR}
										</Button>
									}
								/>
							)}
						</Container>
					</Carousel>
				)}
			</form>
		);
	}
}

export default withStyles(styles)(AddReviewWrapper);

class AddReviewSendButton extends React.Component {
	render() {
		let text = this.props.text;
		return (
			<Button
				datatest="feedback_next_button"
				onClick={
					this.props.disabledFirstButton
						? () => this.props.setError(this.props.scrollToError)
						: this.props.userIsAuth
							? this.props.authHandler
							: () => this.props.openRegistrationHandler()
				}
				fullWidth={true}
				noPaddings={true}
				size="middle"
				disabled={this.props.disabledFirstButton}
				status="purple"
			>
				{text.SEND_REVIEW}
			</Button>
		);
	}
}
